import { render, staticRenderFns } from "./PageEditorToolbarContentBtn.vue?vue&type=template&id=3823bf0d&scoped=true"
import script from "./PageEditorToolbarContentBtn.vue?vue&type=script&lang=js"
export * from "./PageEditorToolbarContentBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3823bf0d",
  null
  
)

export default component.exports